import { PortalModal } from "@/components/portal/PortalModal";
import { useDialogs } from "@/lib/dialogs";
import { CAPABILITIES, MODULES, PLATFORM } from "@/config/platform";
import { isLive } from "@/lib/platformClient";

const Row = ({ name, value, status, testId }) => (
  <div className="integration-row" data-testid={testId}>
    <div><b>{name}</b><br /><code>{value}</code></div>
    <span className={`tag ${status === "LIVE" ? "greentag" : status === "DENIED" ? "goldtag" : "graytag"}`}>{status}</span>
  </div>
);

export const ConnectionDialog = ({ onClose }) => {
  const open = useDialogs();
  return (
    <PortalModal title="Connection to the canonical platform" wide brand onClose={onClose} testId="connection-dialog">
      <div className="notice warn" data-testid="repo-access-blocker"><b>P00 complete:</b> {PLATFORM.repo} @ {PLATFORM.repoCommit} was inspected read-only on {PLATFORM.repoCheckedOn}. Launcher routes are verified. Submissions stay in DEMO MODE until activation is approved: provisioning and partner self-registration have no canonical public API yet, and the platform URL and CORS allow-list are not configured.</div>
      <h3 className="subhead">Environment</h3>
      <div className="integrations">
        <Row name="Platform application URL" value={PLATFORM.appBaseUrl || "REACT_APP_PLATFORM_APP_URL not set"} status={PLATFORM.appBaseUrl ? "SET" : "NOT SET"} testId="conn-app-url" />
        <Row name="Platform API URL" value={PLATFORM.apiBaseUrl || "REACT_APP_PLATFORM_API_URL not set"} status={PLATFORM.apiBaseUrl ? "SET" : "NOT SET"} testId="conn-api-url" />
      </div>
      <h3 className="subhead">Canonical capabilities</h3>
      <div className="integrations">
        {Object.entries(CAPABILITIES).map(([k, c]) => (
          <Row key={k} name={c.label} value={c.contract} status={isLive(k) ? "LIVE" : "DEMO"} testId={`conn-cap-${k}`} />
        ))}
      </div>
      <h3 className="subhead">Route map <span className="tag greentag">VERIFIED IN App.js</span></h3>
      <div className="integrations">
        {MODULES.map((m) => <Row key={m.key} name={m.name} value={m.cap ? `${m.route} · requires ${m.cap}` : m.route} status={m.verified ? "VERIFIED" : "UNVERIFIED"} testId={`conn-route-${m.key}`} />)}
      </div>
      <p className="fineprint">Configuration is set by environment and a reviewed code change, not in the browser. Tenant identity always comes from the platform session, never from URL parameters.</p>
      <div className="modal-actions"><button className="btn blue" onClick={() => open("launcher")} data-testid="conn-view-launcher-button">View launcher</button></div>
    </PortalModal>
  );
};
